import { IconCash } from "@tabler/icons-react";
import "./ClientPayment.scss";
import { Text, Button, Tooltip } from "@mantine/core";
import { openNewTab } from "@/utils/browserUtils";

interface ClientPaymentProps {
  paymentLink: string;
}

const ClientPayment = ({ paymentLink }: ClientPaymentProps) => {
  const handleOpenPaymentLink = () => {
    openNewTab(paymentLink);
  };

  return (
    <div className="panel-container client-payment">
      <div className="panel-header">
        <IconCash size={20} />
        <p>Make a Payment</p>
      </div>

      <div className="panel-body">
        <Text c="dimmed">
          Securely pay your tax professional using their payment platform
        </Text>
        <Tooltip
          label="Your taxpro has not configured a payment link"
          disabled={!!paymentLink}
          withArrow
        >
          <Button
            onClick={handleOpenPaymentLink}
            disabled={!paymentLink}
            size="lg"
            mt={"md"}
          >
            Make a payment
          </Button>
        </Tooltip>
      </div>
    </div>
  );
};

export default ClientPayment;
